import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Translators } from '../../services/shared/translators.service';
import { MatDialog } from '@angular/material/dialog';
import { OpenPageService } from '../../services/shared/open-page.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  idioma: Subscription;
  public appVersion: string = '';
  public currentYear: number = new Date().getFullYear();  // Año dinámico

  constructor(
      private translatorService: Translators,
      public dialog: MatDialog,
      private openPageService: OpenPageService,
  ) {}

  ngOnInit(): void {
    this.appVersion = environment.version;
  }

  openBlank(type: string) {
    this.openPageService.openBlank(type);
  }
}